import * as i0 from '@angular/core';
import { Injectable, ViewChild } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i1$1 from 'ngx-toastr';

class APIDocumentChecklist {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    resetRequiredDocuments(visaType, caseType, caseId, taskId) {
        let pathVars = `/documentChecklist/${visaType}/${caseType}/${caseId}`;
        // if(caseType == 'I140'){
        //   pathVars = `/task/${taskId}/case/${caseId}`;
        // }
        return this.httpClient.post(`${pathVars}/organizeDocuments/reset`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response; // send  full data
            }
        }));
    }
    getRequiredDocuments(visaType, caseType, caseId) {
        let path = `/redesign/documentChecklist/${visaType}/${caseType}/${caseId}`;
        if (caseType == 'I485') {
            path = `/redesign/documentChecklist/${caseType}/PETITION/${caseId}`;
        }
        return this.httpClient.get(path).pipe(map((response) => {
            //if (response.status === 200) {
            return response; // send  full data
            //}
        }));
    }
    postRequiredDocument(visatype, caseType, caseId, taskId, payload) {
        let path = `/${visatype}/${caseType}/${caseId}/redesign/organizeDocuments`;
        // if(caseType =='I140'){
        //   path = `/task/${taskId}/case/${caseId}/redesign/organizeDocuments`;
        // }
        return this.httpClient.post(`${path}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response; // send  full data
            }
        }));
    }
    sendNotification(caseId, payload) {
        return this.httpClient.post(`/documentChecklist/${caseId}/notification/save`, payload).pipe(map((response) => {
            return response; // send  full data
        }));
    }
    saveUploadedDocument(visatype, caseType, caseId, categoryCode, fileCategoryCode, entityId = null, superTaskId, subTaskId, payload) {
        let params = "";
        let otherPath = fileCategoryCode === 'OTHER' ? '/documentChecklist' : '';
        if (entityId) {
            params += `?entityId=${entityId}`;
        }
        let initialPath = `/${visatype}/${caseType}/${caseId}`;
        if (caseType == 'I140') {
            initialPath = `/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/${caseId}`;
        }
        return this.httpClient.post(`${otherPath}${initialPath}/document/category/${categoryCode}/fileCategory/${fileCategoryCode}${params}`, payload).pipe(map((response) => {
            return response; // send  full data
        }));
    }
    saveRequestedDocument(visatype, caseType, caseId, categoryCode, fileCategoryCode, entityId = null, superTaskId, subTaskId, payload) {
        let params = "?tempDoc=true";
        const otherPath = fileCategoryCode === 'OTHER' ? '/documentChecklist' : (caseType != 'I140' ? '/tempDocument' : '');
        if (entityId) {
            params += `&entityId=${entityId}`;
        }
        let initialPath = `/${visatype}/${caseType}/${caseId}`;
        if (caseType == 'I140') {
            initialPath = `/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/${caseId}`;
        }
        return this.httpClient.post(`${otherPath}${initialPath}/document/category/${categoryCode}/fileCategory/${fileCategoryCode}${params}`, payload).pipe(map((response) => {
            return response; // send  full data
        }));
    }
    addDocumentType(caseType, caseId, titleSheetId, payload) {
        return this.httpClient.post(`/documentChecklist/${caseType}/${caseId}/titleSheet/${titleSheetId}/addDocumentType`, payload).pipe(map((response) => {
            return response; // send  full data
        }));
    }
    deleteDocument(visatype, caseType, caseId, documentId, superTaskId, subTaskId) {
        let initialPath = `${visatype}/${caseType}/${caseId}`;
        if (caseType == 'I140') {
            initialPath = `superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/${caseId}`;
        }
        return this.httpClient.delete(`/${initialPath}/document/${documentId}`).pipe(map((response) => {
            return response; // send  full data
        }));
    }
    renameTitleSheet(caseType, taskId, titleSheetId, newName) {
        return this.httpClient.post(`/documentChecklist/${caseType}/task/${taskId}/titleSheet/${titleSheetId}/rename?newName=${newName}`, []).pipe(map((response) => {
            return response; // send  full data
        }));
    }
    getSuperTask(superTaskId) {
        return this.httpClient.get(`/superTask/${superTaskId}/overview`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    getTask(taskId) {
        return this.httpClient.get(`/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getRequestedDocuments(visaType, caseType, caseId, benPetId, isFor) {
        return this.httpClient.get(`/documentChecklist/notification/${visaType}/${caseType}/${caseId}/${isFor}/${benPetId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    notifiReviewer(taskId) {
        return this.httpClient.post(`/documentChecklist/task/${taskId}/notifyReviewer`, []).pipe(map((response) => {
            if (response.status === 200) {
                return response; //send full response
            }
        }));
    }
}
APIDocumentChecklist.ɵfac = function APIDocumentChecklist_Factory(t) { return new (t || APIDocumentChecklist)(i0.ɵɵinject(i1.HttpClient)); };
APIDocumentChecklist.ɵprov = i0.ɵɵdefineInjectable({ token: APIDocumentChecklist, factory: APIDocumentChecklist.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIDocumentChecklist, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseDocumentChecklistLibraryService {
    constructor(toastr, apiService) {
        this.toastr = toastr;
        this.apiService = apiService;
        this.newNode = [];
        this.titleSheetButtonEnabled = true;
        this.observableSubscription$ = new Subject();
        this.docTreeExpandedState = [];
        this.disabledControls = false;
    }
    loadInit() {
        this.getRequiredDocument();
    }
    mapExpansion() {
        if (!this.docTreeExpandedState.length) {
            this.requiredDocumentsTree.forEach(node => {
                this.expandRecursive(node, false);
            });
        }
        else {
            this.requiredDocumentsTree.forEach((node) => {
                let prevExpandStateNode = this.docTreeExpandedState.filter((x) => x.nodeIndex === node['nodeIndex']);
                this.expandRecursive(node, prevExpandStateNode[0]['expanded']);
            });
        }
    }
    viewDocument(item) {
        const docPath = item.substring(23);
        window.open(`${environment.docs}${docPath}`, "_blank");
    }
    getRequiredDocument() {
        return new Promise((resolve, reject) => {
            let tempData = [];
            this.apiService.getRequiredDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                //console.log('response:',response);
                if (response.data) {
                    this.supportingDocuments = response.data;
                    this.newTitleSheetSequenceNo = response.data[response.data.length - 1]["titleSheetSequnceNo"] + 1;
                    response.data.forEach((element, index) => {
                        let obj = {
                            nodeIndex: index,
                            data: element,
                            type: 'parent',
                            children: []
                        };
                        element.documentTypes.sort(function (a, b) {
                            if (null == a.titleSheetDetailSequenceNo) {
                                a.titleSheetDetailSequenceNo = Math.max(...element.documentTypes.map(o => o.titleSheetDetailSequenceNo)) + 1;
                            }
                            return a.titleSheetDetailSequenceNo - b.titleSheetDetailSequenceNo;
                        });
                        let childCount = 0;
                        element.documentTypes.forEach((doc, ind) => {
                            if (doc.fileCategoryCode == 'OTHER' && doc.docName == 'Other') {
                            }
                            else {
                                obj.children.push({
                                    parentIndex: index,
                                    nodeIndex: childCount,
                                    data: doc,
                                    type: 'child'
                                });
                                childCount += 1;
                            }
                        });
                        if (obj.children && obj.children.length > 0) {
                            tempData.push(obj);
                        }
                    });
                    // Sorting temp data while handling null exception before assign to tree node
                    // Objects containing null values will come last in the order
                    tempData = tempData.sort((a, b) => {
                        if (a.data.titleSheetSequnceNo === null) {
                            return 1;
                        }
                        if (b.data.titleSheetSequnceNo === null) {
                            return -1;
                        }
                        if (a.data.titleSheetSequnceNo === b.data.titleSheetSequnceNo) {
                            return 0;
                        }
                        return a.data.titleSheetSequnceNo < b.data.titleSheetSequnceNo ? -1 : 1;
                    });
                    this.requiredDocumentsTree = tempData;
                    this.mapExpansion();
                    resolve(response.data);
                }
                else {
                    reject(response.message);
                }
            });
        });
    }
    expandRecursive(node, isExpand) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseDocumentChecklistLibraryService.ɵfac = function BaseDocumentChecklistLibraryService_Factory(t) { return new (t || BaseDocumentChecklistLibraryService)(i0.ɵɵinject(i1$1.ToastrService), i0.ɵɵinject(APIDocumentChecklist)); };
BaseDocumentChecklistLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseDocumentChecklistLibraryService, factory: BaseDocumentChecklistLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseDocumentChecklistLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.ToastrService }, { type: APIDocumentChecklist }]; }, { inplaceEditor: [{
            type: ViewChild,
            args: ['inplace', { static: false }]
        }], inplaceEditorCustom: [{
            type: ViewChild,
            args: ['inplaceCustom', { static: false }]
        }] }); })();

/*
 * Public API Surface of base-document-checklist-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIDocumentChecklist, BaseDocumentChecklistLibraryService };
//# sourceMappingURL=base-document-checklist-library.js.map
